import { apiService } from './api.service';

/**
 * Capacités annoncées par l'instance (contrat C2).
 *
 * Le front ne devine pas ce dont l'instance est capable : il le lui demande.
 * Pas de drapeau de configuration, pas de variable d'environnement — les deux
 * se désynchronisent de l'état réel sans que personne ne s'en aperçoive.
 *
 * La lecture passe par le tunnel `/proxy/api` déjà en place, vers la route de
 * contexte RH d'Odoo. Si le module RH n'est pas installé, cette route n'existe
 * pas : **son absence est la réponse**, et la capacité vaut faux.
 *
 * En cas de doute — panne, corps inattendu, valeur non booléenne — on masque.
 * Une capacité annoncée à tort ferait apparaître une option qui échouerait
 * ensuite côté serveur ; l'inverse ne fait que cacher une possibilité.
 */
export const CAPACITES_PAR_DEFAUT = { compte_portail: false };

export async function chargerCapacites() {
    try {
        const reponse = await apiService.getElement('/rh/contexte');
        const capacites = reponse?.data?.capacites;
        if (!capacites || typeof capacites !== 'object') {
            return { ...CAPACITES_PAR_DEFAUT };
        }
        return { compte_portail: capacites.compte_portail === true };
    } catch (erreur) {
        return { ...CAPACITES_PAR_DEFAUT };
    }
}
